import { ChangeEvent, useState } from 'react';
import Select, { components } from 'react-select';
import {
  genders,
  numberCaseRegex,
  roles,
  specialCharacterRegex,
  upperCaseRegex,
} from '../constant/constant';
import CustomDatePicker from '../components/CustomDatePicker';
import instance from '../config/axios';
import { useAuth } from 'react-oidc-context';
import { DownCaretIcon } from '../assets/svgImages';
import { createUserValidator } from '../validator';
import { Tooltip } from 'react-tooltip';
import showToast from '../components/ToastComponent';
import { validateEmail } from '../utils/validateEmail';
import { InternalUserProps } from '../interface/interface';
import moment from 'moment';
// import { UserContext } from '../context/userContext';

const OnboardUser = () => {
  const { user } = useAuth();
  // const auth = useAuth();
  // const { nativeView } = useContext(UserContext);
  const [data, setData] = useState<InternalUserProps>({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    dob: undefined,
    gender: '',
    role: '',
  });

  const [error, setError] = useState<boolean>(false);
  const [show, setShow] = useState(false);

  const [gender, setGender] = useState<null | { label: string; value: string }>(
    null,
  );

  const [role, setRole] = useState<null | { label: string; value: string }>(
    null,
  );

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleDate = (date: Date) => {
    setData({
      ...data,
      dob: new Date(date),
    });
  };

  const clearInput = () => {
    setData({
      firstName: '',
      lastName: '',
      password: '',
      email: '',
      dob: undefined,
      gender: '',
      role: '',
    });
    setGender(null);
    setRole(null);
  };

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    try {
      // const session = window.sessionStorage.getItem(
      //   `oidc.user:${process.env.AUTHENTIK_HOST}/application/o/${nativeView ? `mvr-mobile:${process.env.MOBILE_AUTHENTIK_CLIENT_ID}` : `mvr:${process.env.AUTHENTIK_CLIENT_ID}`}`,
      // );

      // if (!session) {
      //   console.log('Session Timeout Sign out the user');
      //   auth.signoutRedirect();
      // }

      e.preventDefault();

      const validate = createUserValidator(data);

      if (!data || validate) {
        console.log(validate);
        setError(true);
        return;
      }

      const response = await instance.post(
        '/api/v1/user/create',
        {
          ...data,

          dob: data.dob
            ? moment(data.dob).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
            : '-',
        },
        {
          headers: {
            Authorization: `Bearer ${user?.access_token}`,
          },
        },
      );

      if (response.status === 201) {
        showToast({
          message: 'User created successfully',
          type: 'success',
        });
      } else {
        showToast({
          message: response.data.message,
          type: 'warning',
        });
      }
      clearInput();
    } catch (err) {
      console.error(err);
      showToast({
        message: 'Error while creating user',
        type: 'error',
      });
    }
  };

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <DownCaretIcon />
      </components.DropdownIndicator>
    );
  };

  return (
    <div className="space-y-10 divide-y divide-gray-900/10 add-user">
      <div>
        <h2 className="mb-5 text-2xl font-semibold text-primary-blue-500">
          Onboard User
        </h2>
        <div className="bg-white shadow rounded-xl">
          <div className="px-4 py-6 sm:p-8">
            <div className="grid  grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-2">
                <label
                  htmlFor="first-name"
                  className="text-sm font-semibold  text-secondary-pink-700"
                >
                  First name <span className="text-red-500">*</span>
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    name="firstName"
                    id="first-name"
                    autoComplete="given-name"
                    className={`text-sm font-regular border  rounded-md p-2 w-full 
                      ${error && !data.firstName ? 'border-red-400' : 'border-secondary-cornflowerblue-400'}`}
                    value={data.firstName}
                    onChange={(e) => handleInput(e)}
                  />
                </div>
                {error && !data.firstName && (
                  <small className="text-red-600">First name is Required</small>
                )}
              </div>
              <div className="sm:col-span-2">
                <label
                  htmlFor="last-name"
                  className="text-sm font-semibold  text-secondary-pink-700"
                >
                  Last name <span className="text-red-500">*</span>
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    name="lastName"
                    id="last-name"
                    autoComplete="family-name"
                    className={`text-sm font-regular border  rounded-md p-2 w-full 
                      ${error && !data.lastName ? 'border-red-400' : 'border-secondary-cornflowerblue-400'}`}
                    value={data.lastName}
                    onChange={(e) => handleInput(e)}
                  />
                </div>
                {error && !data.lastName && (
                  <small className="text-red-600">Last name is Required</small>
                )}
              </div>

              {/* <div className="sm:col-span-2">
                  <label
                    htmlFor="user-name"
                    className="text-sm font-semibold  text-secondary-pink-700"
                  >
                    User name <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="userName"
                      id="user-name"
                      autoComplete="family-name"
                      className={`text-sm font-regular border  rounded-md p-2 w-full 
                      ${error && !data.userName ? 'border-red-400' : 'border-secondary-cornflowerblue-400'}`}
                      value={data.userName}
                      onChange={(e) => handleInput(e)}
                    />
                  </div>
                  {error && !data.userName && (
                    <small className="text-red-600">
                      Last name is Required
                    </small>
                  )}
                </div> */}

              <div className="sm:col-span-2">
                <label
                  htmlFor="email"
                  className="text-sm font-semibold  text-secondary-pink-700"
                >
                  Email address <span className="text-red-500">*</span>
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    className={`text-sm font-regular border 
                        rounded-md p-2 w-full 
                        ${error && !data.email && !validateEmail(data.email) ? 'border-red-400' : 'border-secondary-cornflowerblue-400'}`}
                    onChange={(e) => handleInput(e)}
                    value={data.email}
                  />
                </div>
                {error && !data.email ? (
                  <small className="text-red-600">Email is required</small>
                ) : error && !validateEmail(data.email) ? (
                  <small className="text-red-600">
                    Email Not in valid form
                  </small>
                ) : (
                  ''
                )}
              </div>

              <div className="sm:col-span-2">
                <label
                  htmlFor="password"
                  className="text-sm font-semibold  text-secondary-pink-700"
                >
                  <div className="flex justify-between">
                    <div className="block">
                      Password <span className="text-red-500">*</span>
                    </div>
                    <a data-tooltip-id="password-info">ℹ️</a>
                    <Tooltip id="password-info">
                      <ul style={{ listStyle: 'initial' }} className="p-5">
                        <li>Password must be at least 8 characters long.</li>
                        <li>
                          Password must contain at least one special character.
                        </li>
                        <li>Password must contain at least one digit</li>
                        <li>
                          Password must contain at least one uppercase letter.
                        </li>
                      </ul>
                    </Tooltip>
                  </div>
                </label>

                <div className="mt-2 relative">
                  <input
                    id="passowrd"
                    name="password"
                    type={show ? 'text' : 'password'}
                    className={`text-sm font-regular border  rounded-md p-2 w-full 
                      ${error && !data.password ? 'border-red-400' : 'border-secondary-cornflowerblue-400'}`}
                    onChange={(e) => handleInput(e)}
                    value={data.password}
                  />
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                    {show ? (
                      <span onClick={() => setShow(!show)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573
                               3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                      </span>
                    ) : (
                      <span onClick={() => setShow(!show)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228
                               6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3
                                3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                          />
                        </svg>
                      </span>
                    )}
                  </div>
                </div>
                {error && !data.password ? (
                  <small className="text-red-600">Password is Required</small>
                ) : error && data.password.split('').length < 8 ? (
                  <small className="text-red-600">
                    Password Must be More than 8 character
                  </small>
                ) : error &&
                  data.password &&
                  !specialCharacterRegex.test(data.password) ? (
                  <small className="text-red-600">
                    Password Must Contain one Special Character
                  </small>
                ) : error &&
                  data.password &&
                  !upperCaseRegex.test(data.password) ? (
                  <small className="text-red-600">
                    Password Must Contain one Upper Case Character
                  </small>
                ) : error &&
                  data.password &&
                  !numberCaseRegex.test(data.password) ? (
                  <small className="text-red-600">
                    Password Must Contain one Number
                  </small>
                ) : (
                  ''
                )}
              </div>

              <div className="sm:col-span-2">
                <label className="text-sm font-semibold  text-secondary-pink-700">
                  Gender <span className="text-red-500">*</span>
                </label>
                <div className="mt-2">
                  <Select
                    value={gender}
                    options={genders as any}
                    onChange={(selectedOption) => {
                      setGender(selectedOption);
                      setData({
                        ...data,
                        gender: selectedOption!.value,
                      });
                    }}
                    isSearchable={false}
                    components={{
                      DropdownIndicator,
                      IndicatorSeparator: () => null,
                    }}
                    className={error && !data.gender ? 'select-error' : ''}
                  />
                </div>
                {error && !data.gender && (
                  <small className="text-red-600">Gender is required</small>
                )}
              </div>

              <div className="sm:col-span-2">
                <label className="text-sm font-semibold  text-secondary-pink-700">
                  Date Of Birth
                </label>
                <div className="mt-2">
                  <div className="relative custom-date-picker">
                    <CustomDatePicker
                      value={data.dob}
                      handleDate={handleDate}
                      // className={error && !data.dob ? 'dob-error' : ''}
                      maxDate
                    />
                  </div>
                </div>
                {/* {error && !data.dob && (
                    <small className="text-red-600">DOB is required</small>
                  )} */}
              </div>

              <div className="sm:col-span-2">
                <label className="text-sm font-semibold  text-secondary-pink-700">
                  Role <span className="text-red-500">*</span>
                </label>
                <div className="mt-2">
                  <Select
                    value={role}
                    options={roles as any}
                    onChange={(selectedOption) => {
                      setRole(selectedOption);
                      setData({
                        ...data,
                        role: selectedOption!.value,
                      });
                    }}
                    isSearchable={false}
                    components={{
                      DropdownIndicator,
                      IndicatorSeparator: () => null,
                    }}
                    className={error && !role?.value ? 'select-error' : ''}
                  />
                </div>
                {error && !role?.value && (
                  <small className="text-red-600">Role is Required</small>
                )}
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end gap-x-6 px-4 py-4 sm:px-8">
            <button
              type="button"
              className="bg-white border border-solid border-primary-blue-500 text-primary-blue-500 w-24 px-4 py-2 rounded"
              onClick={clearInput}
            >
              Clear
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              className="bg-primary-blue-500 border border-solid border-primary-blue-500 text-white px-4 py-2 w-24 rounded"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardUser;
